module.exports = {
  key: "authentication",

  authentication: {
    layout: {

    },
    components: {
      auth: {

      },
      forget_password: {

      },
      login_footer: {

      },
    },
    router_title: {

    },
    views: {},
    route_titles: {

    },
  },
  attribute: {

  },
  placeholder: {

  },
};
